import { render, staticRenderFns } from "./icon-information.vue?vue&type=template&id=1d9db78e&"
import script from "./icon-information.vue?vue&type=script&lang=js&"
export * from "./icon-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports